import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatError } from '@angular/material/input';
import { MatList, MatListItem } from '@angular/material/list';
import { Observable } from 'rxjs';
import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'bt-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, MatError, MatList, MatListItem]
})
export class FormErrorsComponent implements OnInit {
  @Input() errorName;
  errors: Observable<string[]>;

  constructor(private errorService: ErrorService) {
  }

  ngOnInit() {
    this.errors = this.errorName
      ? this.errorService.messagesFor(this.errorName)
      : this.errorService.messages(true);
  }
}
